import type { CreateSampleOrdersCardMountData } from '../../../../global_state/src/cardLayersReducer';

// Real sample-demand data used to open the create-sample-orders card for local development.
const realCreateSampleOrdersCardMountData: CreateSampleOrdersCardMountData = {
    brand: {
        brandName: 'Jack & Jones',
        brandNumber: '04',
    },
    collectionNumber: 58813,
    collectionName: '27 MAIN #3 (2027 MAIN #3)',
    supplierNumber: '400579',
    styles: [
        {
            styleNumber: 12320950,
            styleOptions: [
                {
                    styleOptionNumber: 5291231,
                    isSalesSample: true,
                    isMeetingSample: true,
                },
            ],
        },
        {
            styleNumber: 12321169,
            styleOptions: [
                {
                    styleOptionNumber: 5294453,
                    isSalesSample: true,
                    isMeetingSample: false,
                },
                {
                    styleOptionNumber: 5294456,
                    isSalesSample: true,
                    isMeetingSample: false,
                },
                {
                    styleOptionNumber: 5294452,
                    isSalesSample: true,
                    isMeetingSample: false,
                },
                {
                    styleOptionNumber: 5294454,
                    isSalesSample: true,
                    isMeetingSample: false,
                },
                {
                    styleOptionNumber: 5294455,
                    isSalesSample: true,
                    isMeetingSample: false,
                },
            ],
        },
        {
            styleNumber: 12321374,
            styleOptions: [
                {
                    styleOptionNumber: 5294777,
                    isSalesSample: false,
                    isMeetingSample: true,
                },
                {
                    styleOptionNumber: 5294775,
                    isSalesSample: false,
                    isMeetingSample: true,
                },
                {
                    styleOptionNumber: 5294774,
                    isSalesSample: false,
                    isMeetingSample: true,
                },
                {
                    styleOptionNumber: 5294776,
                    isSalesSample: false,
                    isMeetingSample: true,
                },
            ],
        },
        {
            styleNumber: 12307862,
            styleOptions: [
                {
                    styleOptionNumber: 5259750,
                    isSalesSample: true,
                    isMeetingSample: true,
                },
                {
                    styleOptionNumber: 5259748,
                    isSalesSample: true,
                    isMeetingSample: true,
                },
                {
                    styleOptionNumber: 5259749,
                    isSalesSample: true,
                    isMeetingSample: true,
                },
            ],
        },
    ],
};

export { realCreateSampleOrdersCardMountData };
